import { render, staticRenderFns } from "./taskProgressTag.vue?vue&type=template&id=6bd5927a&scoped=true"
import script from "./taskProgressTag.vue?vue&type=script&lang=js"
export * from "./taskProgressTag.vue?vue&type=script&lang=js"
import style0 from "./taskProgressTag.vue?vue&type=style&index=0&id=6bd5927a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5927a",
  null
  
)

export default component.exports